// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import tokens from '@microsoft/atlas-css/dist/tokens.json';
import type { AtlasTokens } from '@microsoft/atlas-css/dist/tokens';

export const atlasTokens = tokens as AtlasTokens;
